import React, { useEffect } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import marketing from '../../../services/marketing';
import PixelsService from '../../../services/pixels';
import { useHistory } from 'react-router-dom';
import AdobeScript from '../../../services/adobeScript';
import OtherOptions from './otherOptions'
import { PRODUCT } from '../../../models/websiteTypesConstants';

function DeclinedTemporal() {    

    const brandSettings = useStoreState(state => state.siteSettingsModel.brandSettings);
    const setting = useStoreState(state => state.siteSettingsModel);
    const productSettings = useStoreState(state => state.siteSettingsModel.productSettings);
    const showOnDeclined = useStoreState(state => state.siteSettingsModel.showOnDeclined);
    const webAssetsBaseUrlSettings = useStoreState(state => state.siteSettingsModel.webAssetsBaseUrlSettings);
    const applicationResult = useStoreState(state => state.applicationResultModel.applicationResult);
    const paymentPixels = useStoreState(state => state.paymentPixels);
    const setPaymentPixels = useStoreActions(actions => actions.setPaymentPixels);
    const utms = new marketing()
    const Flow = useStoreState(state => state.siteSettingsModel.mainSettings.Flow);
    const declineTemporalMessage = "Unfortunately, we are not able to complete the processing of your application right now. Please check your email for important information from us regarding additional information we need.";
    const getRoutingSettings = useStoreActions(state => state.routingSettingsModel.getRoutingSettings);
    const PixelService = new PixelsService();
    const WaterfallEvents = { "DM" : 9, "PREQUAL" : 4, "CFC" : 16, "STANDALONE" : 22, "CS" : 28};
    const history = useHistory();
    const adobe = new AdobeScript();
    const productName = brandSettings.ProductName === PRODUCT.Fit ? brandSettings.ProductName.toUpperCase()+ '™' : brandSettings.ProductName === PRODUCT.Grand.bank ? 'Grand.bank® Plus' : brandSettings.ProductName +'®';

    useEffect(() => {
        const disableBackButton = (event) => {
          event.preventDefault();
          window.history.forward();
        };
    
        window.addEventListener('popstate', disableBackButton);
    
        return () => {
            //window.removeEventListener('popstate', disableBackButton);
        };
      }, []);

    useEffect(() => {
        
        if(paymentPixels === false){
            PixelService.pageView("/pendinfo").event("google", Flow, "pendinfo");
            adobe.event('pendinfo')
            utms.trackEvent(WaterfallEvents[Flow] || 0, Flow, applicationResult.ref_number, productSettings.ProductId, "Flow");
            if(typeof window.nid === 'function') {
                window.nid('closeSession')
            }
            getRoutingSettings({ Url: setting.domain, Route: "/decision"});
            setPaymentPixels(true)
        }
    },[])

    useEffect(() => {
        return () => {
            if (history.action === 'POP') {
                history.go(1);
            }
        };
    }, [history]);

    useEffect(() => {
        if (applicationResult.product_code || typeof applicationResult.product_code !== 'undefined' || applicationResult.product_code !== "") {
            localStorage.setItem("TCProductCode", applicationResult.product_code)
        }

    }, [applicationResult.product_code])

    function getNoReplyEmail(){
        if(productSettings.NoReplyEmail){
            return productSettings.NoReplyEmail
        }
        if(brandSettings.ProductName === PRODUCT.Revel){
            return "noreply@revelcard.com";
        }else{
            return "noreply@your"+brandSettings.ProductName.toLowerCase()+"card.com";
        }
    }

    return (
        <div className="resultpage">
            <div className={(brandSettings.ProductName === PRODUCT.Grand.bank ? " ribbonGB" : "ribbon")} style={{ backgroundColor: brandSettings.Primary }}>
                {(Flow === "PREQUAL" || Flow === "PREQUALSTRAIGHT" || Flow === 'PREQUALFIT') ? <h1>Your Pre-qualification Results Are...</h1> : <h1>Thank you for applying...</h1>}
            </div>
            <div className="container">
                {
                    // eslint-disable-next-line  no-whitespace-before-property
                    applicationResult.ref_number !== "" && applicationResult.ref_number !== null ?
                    <div className="row" >
                        <div className="col-lg-12 text-center">
                            <h4 style={{"color" : brandSettings.ProductName === PRODUCT.Grand.bank ? brandSettings.Primary : "#f56928"}}>Reference #: {applicationResult.ref_number}</h4>
                        </div>
                    </div>
                    : 
                    <></>
                }         
            
                <div className='row'>
                    <div className='card gbCard'>
                        <div className='card-body no-bottom-margin  row' style={{"marginBottom" : "0 !important"}}>
                            <div className={brandSettings.ProductName === PRODUCT.Revel ? "col-lg-4 text-center" : "col-lg-4"}><img style={{width :((brandSettings.ProductName === PRODUCT.Revel || brandSettings.ProductName === PRODUCT.Grand.bank) ? "250px" : "")}} className="col-lg-12 gb-image" src={(brandSettings.ProductName === PRODUCT.Surge) ? ((Flow === "DM") ? webAssetsBaseUrlSettings.CdnImage+"Surge/all-colors.png" : webAssetsBaseUrlSettings.CdnImage+"Surge/card-silver.png") : brandSettings.CardImage} alt={brandSettings.ProductName} /></div>
                            <div className="col-lg-8 pt-0 result-message declined">
                                <p className='text-justify'>
                                <strong>Thank you for your interest in {productName} Mastercard®, issued by{brandSettings.BankName} and serviced by Continental Finance Company. At this time, a credit offer is not available for the following reason(s):</strong>
                                </p>
                                <p className={`decline-reason gbresponse ${brandSettings.ProductName === PRODUCT.Grand.bank ? 'gbColor' : 'regularColor'}`}>
                                    {declineTemporalMessage}
                                </p>
                                {
                                    !showOnDeclined ?
                                    <p className='text-justify mb-0'>
                                        <strong>
                                                Please check your email for a message from <span style={{ color: "#008cba" }}><u>{ getNoReplyEmail() }</u></span>. You
                                                may need to review your junk email for this message.
                                        </strong>
                                    </p>
                                    :
                                    <></>
                                }
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
            {((setting.DeclineOffers !== null && setting.DeclineOffers.some(offer => offer.Name === "BMGPendinfoOffer"))) &&
                  <div className="ribbon" style={{ backgroundColor: brandSettings.Primary}}>
                      {
                          <h1>There is another option available</h1>       
                      }
                      
                  </div> 
                }
                {(setting.DeclineOffers !== null && setting.DeclineOffers.some(offer => offer.Name === "BMGPendinfoOffer")) && <OtherOptions />}
              
        </div>
    );

}

export default DeclinedTemporal;